import {report_error} from "@cling/lib.shared.debug"
import {RateLimiter} from "@cling/lib.shared.utils/rate_limiter"

const report_limiter = new RateLimiter({max_calls: 3, per: [5, "minutes"]})

/**
 * Report the errors a worker does tell us about. Neither event fires when the browser simply kills
 * the worker, so this is a diagnostic and never a way to notice that the worker is gone.
 */
export function listen_for_worker_errors(
    worker: Pick<Worker, "addEventListener">,
    port: Pick<MessagePort, "addEventListener">,
) {
    const report = (
        message: string,
        event: {type: string; message?: string; filename?: string; lineno?: number},
    ) => {
        report_limiter.run((within_limit) => {
            if (within_limit) {
                report_error(message, {
                    message: event.message,
                    filename: event.filename,
                    lineno: event.lineno,
                    type: event.type,
                })
            }
        })
    }
    worker.addEventListener("error", (event) => report("[worker] Worker reported an error", event))
    port.addEventListener("messageerror", (event) =>
        report("[worker] Worker sent a message we could not read", event),
    )
}

/**
 * Kill the worker the way the browser does, for tests and for trying things out by hand. A
 * `SharedWorker` cannot be terminated by a client, so its port is closed instead, which looks the
 * same from the page.
 */
export function install_kill_worker_hook(
    worker: Worker | SharedWorker,
    port: MessagePort | Worker,
) {
    if (!cling.dev && !window._under_test) {
        return
    }
    cling.__kill_worker = () => {
        if (worker instanceof Worker) {
            worker.terminate()
        } else {
            ;(port as MessagePort).close()
        }
    }
}
